import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { BaseColumnComponent } from '~components/dynamic-table/column-components/base-column.component';
import { TranslationStringColumnModel } from '~components/dynamic-table/models/column-types/translation-string-column.model';
import { Identifyable } from '~core/abstractions/identifyable';
import { ArcFormControlInterface } from '~core/utils/arc-form-control';
import { TranslationInputComponent } from '../../../form/translation-input/translation-input.component';

@Component({
    selector: 'arc-translation-string-column',
    templateUrl: './translation-string-column.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [TranslationInputComponent]
})
export class TranslationStringColumnComponent<T extends Identifyable<TId>, TId = number> extends BaseColumnComponent<T, TId> {
    @HostBinding('class') classList = 'h-full';
    get castedColumnModel(): TranslationStringColumnModel {
        return this.columnModel as TranslationStringColumnModel;
    }
    get controlDe(): ArcFormControlInterface {
        return this.formGroup?.get(this.castedColumnModel.controlNameDe) as ArcFormControlInterface;
    }
    get controlEn(): ArcFormControlInterface {
        return this.formGroup?.get(this.castedColumnModel.controlNameEn) as ArcFormControlInterface;
    }
    get controlFr(): ArcFormControlInterface {
        return this.formGroup?.get(this.castedColumnModel.controlNameFr) as ArcFormControlInterface;
    }
    get controlIt(): ArcFormControlInterface {
        return this.formGroup?.get(this.castedColumnModel.controlNameIt) as ArcFormControlInterface;
    }
}
